const dropdownHeader = document.querySelector('.dropdown-header');
const dropdownContent = document.querySelector('.dropdown-content');
const selectedCountryName = document.getElementById('selected-country-name');
const selectedCountryFlag = document.getElementById('selected-country-flag');

dropdownHeader.addEventListener('click', function () {
    if (dropdownContent.style.display === 'block') {
        dropdownContent.style.display = 'none';
        dropdownHeader.classList.remove("open");
    } else {
        dropdownContent.style.display = 'block';
        dropdownHeader.classList.add("open");
    }
});
